import { purchaseHistoryService } from '../../../services'

export default (id) => {
	return new Promise(async (resolve, reject) => {
		await purchaseHistoryService.getDetalleSolicitud(id)
			.then(response => resolve(response))
			.catch(err => reject({error: true}))
	})
}
